import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { useDevice } from "@pushpress/shared-components";
import { useAnalytics } from "../../components/providers/AnalyticsProvider/AnalyticsProvider";
import ErrorFallback from "./components/ErrorFallback";
import LogIn from "./components/LogIn";
import AddPayment from "./components/AddPayment";
import { USER_UUID, ACCESS_TOKEN, CLIENT_UUID } from "./constants";
import { cookieAttributes } from "./helpers";

export default function App() {
  const { trackEvent } = useAnalytics();
  const { isMobile } = useDevice();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  const [isAuthenticated, setIsAuthenticated] = useState(
    !!Cookies.get(ACCESS_TOKEN) && !!sessionStorage.getItem(USER_UUID),
  );

  const clientUuid =
    searchParams.get("client_uuid") || sessionStorage.getItem(CLIENT_UUID);

  const requestType = searchParams.get("request_type");

  trackEvent("Add Payment Viewed", {
    is_mobile: isMobile,
    request_type: requestType,
    client_uuid: clientUuid,
  });

  useEffect(() => {
    if (!isAuthenticated) {
      Cookies.remove(ACCESS_TOKEN, cookieAttributes);
    }
  }, [isAuthenticated]);

  if (!clientUuid) {
    return <ErrorFallback />;
  }

  if (isAuthenticated) {
    return <AddPayment clientUuid={clientUuid} requestType={requestType} />;
  }

  return (
    <LogIn clientUuid={clientUuid} setIsAuthenticated={setIsAuthenticated} />
  );
}
